import { TableCell, TableRow } from "@mui/material";
import React from "react";
import styles from "./NoResultFound.module.css";
import { ReactComponent as NoDataFound } from "../../assets/images/NoDataFound.svg";

const NoResultFound = ({ description, isTableView = true }) => {
  return (
    <>
      {isTableView ? (
        <TableRow>
          <TableCell sx={{ border: "none" }} colSpan={6}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "calc(100vh - 410px)",
              }}
            >
              <NoDataFound />
              <div className={styles.noDataFoundTitle}>No result found!</div>
              <div className={styles.noDataFoundDescription}>
                {description || ""}
              </div>
            </div>
          </TableCell>
        </TableRow>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
          }}
        >
          <NoDataFound />
          <div className={styles.noDataFoundTitle}>No result found!</div>
          <div className={styles.noDataFoundDescription}>
            {description || ""}
          </div>
        </div>
      )}
    </>
  );
};

export default NoResultFound;
